var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import HotelIcon from "@travel/shared/assets/icons/icon-image-broken.svg";
import styles from "./image.module.css";
export function Image(_a) {
    var _b;
    var className = _a.className, src = _a.src, _c = _a.alt, alt = _c === void 0 ? "" : _c, _d = _a.width, width = _d === void 0 ? 500 : _d, _e = _a.height, height = _e === void 0 ? 500 : _e, _f = _a.fits, fits = _f === void 0 ? false : _f, _g = _a.cover, cover = _g === void 0 ? false : _g, _h = _a.fallback, fallback = _h === void 0 ? _jsx(DefaultImageFallback, { className: className, fits: fits }) : _h, rest = __rest(_a, ["className", "src", "alt", "width", "height", "fits", "cover", "fallback"]);
    var _j = __read(useState(false), 2), hasError = _j[0], setHasError = _j[1];
    useEffect(function () {
        setHasError(false);
    }, [src]);
    return hasError ? (_jsx(_Fragment, { children: fallback })) : (_jsx("img", { className: classNames(className, (_b = {},
            _b[styles["fits"]] = fits,
            _b[styles["cover"]] = cover,
            _b)), src: src, alt: alt, width: width, height: height, onError: function () { return setHasError(true); } }));
}
export function DefaultImageFallback(_a) {
    var _b;
    var className = _a.className, fits = _a.fits;
    return (_jsx("div", { className: classNames(styles["fallback"], className, (_b = {},
            _b[styles["fits"]] = fits,
            _b)), children: _jsxs("div", { className: styles["content"], children: [_jsx(HotelIcon, { className: styles["icon"], width: 32, height: 32 }), _jsx("div", { className: styles["text"], children: "Image Not Found" })] }) }));
}
var IMAGE_CACHE = new Set();
export function loadImage(src) {
    return new Promise(function (resolve, reject) {
        if (IMAGE_CACHE.has(src))
            return resolve();
        var image = new window.Image();
        image.onload = function () {
            IMAGE_CACHE.add(src);
            resolve();
        };
        image.onerror = function () { return reject(); };
        image.src = src;
    });
}
